export default "__VITE_ASSET__DKAzM7zL__"